/* Keep native purchase controls ahead of the observed app add-on widget.
 * Move existing controls within their parent: preserve handlers, form ownership,
 * app selection state, and keyboard order. Unknown app layouts are left alone.
 */
(function () {
  'use strict';
  if (window.ldsPurchaseLayout) return;
  window.ldsPurchaseLayout = true;
  var observers = new WeakMap();

  function arrange(root) {
    root.querySelectorAll('[data-product-form] lb-upsell-product-page-addon').forEach(function (addon) {
      var parent = addon.parentElement;
      if (!parent || !parent.classList.contains('product-form__item--submit')) return;
      var button = Array.from(parent.children).find(function (child) {
        return child.matches('[data-add-to-cart]');
      });
      if (!button) return;
      if (addon.compareDocumentPosition(button) & Node.DOCUMENT_POSITION_FOLLOWING) {
        parent.insertBefore(button, addon);
      }
      var payment = Array.from(parent.children).find(function (child) {
        return child.matches('.shopify-payment-button');
      });
      if (payment && (addon.compareDocumentPosition(payment) & Node.DOCUMENT_POSITION_FOLLOWING)) {
        parent.insertBefore(payment, addon);
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-purchase-layout]').forEach(function (root) {
      if (observers.has(root)) return;
      arrange(root);
      var observer = new MutationObserver(function () { arrange(root); });
      observer.observe(root, { childList: true, subtree: true });
      observers.set(root, observer);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-purchase-layout]').forEach(function (root) {
      var observer = observers.get(root);
      if (observer) observer.disconnect();
      observers.delete(root);
    });
  });
}());
